import React from "react";
import {
  type Banner,
  type Customer,
  getAnnouncementBanner,
  getClient,
  getResourcePage,
  groq,
  type ResourcePage,
  getDefaultLogos,
} from "lib/sanity";
import { type GetStaticPaths, type GetStaticProps, type NextPage } from "next";
import { ResourcePageTemplate } from "components/resources/resource-template";

type PageProps = {
  defaultLogos: Customer[];
  resourcePage: ResourcePage;
  announcementBanner?: Banner;
};

const DynamicResourcePage: NextPage<Readonly<PageProps>> = ({ defaultLogos, resourcePage, announcementBanner }) => {
  return <ResourcePageTemplate defaultLogos={defaultLogos} announcementBanner={announcementBanner} {...resourcePage} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const slugs: Array<{ slug: string }> = await getClient(false).fetch(
    groq`*[_type == "resource" && generateLandingPage] { slug }`,
  );

  return {
    paths: slugs.map(({ slug }: { slug: string }) => ({ params: { slug } })),
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps<PageProps> = async ({ params }) => {
  const slug = String(params?.slug);

  const [resourcePage, announcementBanner, defaultLogos] = await Promise.all([
    getResourcePage(slug),
    getAnnouncementBanner(),
    getDefaultLogos(),
  ]);

  if (!resourcePage) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      defaultLogos,
      resourcePage,
      announcementBanner,
    },
    revalidate: 60,
  };
};

export default DynamicResourcePage;
